import axios from "axios";

type eventJoinProps = {
    paramId: string;
    selectedDate: string;
    rotaryCd:  string;
}


/**
 * イベント参加IDを取得するAPI
 */

export async function getEventJoinId(props: eventJoinProps){
    try{
        //  API呼出し
        const response = await axios.get(process.env.REACT_APP_PATH + `/makeup/get-eventjoin`, {
            params:{
                paramId: props.paramId,
                selectedDate:  props.selectedDate,
                rotaryCd: props.rotaryCd
            }
        })
        return JSON.parse(JSON.stringify(response.data))[0].event_join_id

    }catch(error){
        console.warn(error)
    }

}